'use client'

import React, { useState } from 'react'
import { createContainer } from 'unstated-next'

import { useScrollDirection } from '@syconium/little-miss-figgy/dist/lib/hooks/useScrollDirection'

import {
  headerHeightPixels,
  promoBarHeightDesktopPixels,
  promoBarHeightMobilePixels,
} from '../../constants'
import { cookieKeys } from '../_config/Cookies.config'

import { useCookies } from './CookiesProvider.client'

type NavHeaderArgs = {
  hasPages: boolean
}

type NavHeaderState = {
  currentPromoBarHeightMobile: number
  currentPromoBarHeightDesktop: number
  currentHeaderHeightMobile: number
  currentHeaderHeightDesktop: number
  setPromoBarIsVisible: React.Dispatch<React.SetStateAction<boolean>>
  promoBarIsVisible: boolean
  currentPromoBarAndNavHeightMobile: number
  currentPromoBarAndNavHeightDesktop: number
}

const useNavHeaderImpl = (initialState?: NavHeaderArgs): NavHeaderState => {
  const [cookies, _setCookie] = useCookies([cookieKeys.promoBarDismissed.key])
  const [promoBarIsVisible, setPromoBarIsVisible] = useState(true)
  const isPromoBarDismissed = cookies['figs-promo-bar-dismissed'] === 'true'
  const currentPromoBarHeightMobile =
    isPromoBarDismissed || !initialState?.hasPages ? 0 : promoBarHeightMobilePixels
  const currentPromoBarHeightDesktop =
    isPromoBarDismissed || !initialState?.hasPages ? 0 : promoBarHeightDesktopPixels

  const scrollDirection = useScrollDirection()

  const currentHeaderHeightMobile = scrollDirection === 'down' ? 0 : headerHeightPixels
  const currentHeaderHeightDesktop = headerHeightPixels

  const currentPromoBarAndNavHeightDesktop =
    currentHeaderHeightDesktop + (promoBarIsVisible ? currentPromoBarHeightDesktop : 0)
  const currentPromoBarAndNavHeightMobile =
    currentHeaderHeightMobile + (promoBarIsVisible ? currentPromoBarHeightMobile : 0)
  return {
    currentPromoBarHeightMobile,
    currentPromoBarHeightDesktop,
    currentHeaderHeightMobile,
    currentHeaderHeightDesktop,
    setPromoBarIsVisible,
    promoBarIsVisible,
    currentPromoBarAndNavHeightDesktop,
    currentPromoBarAndNavHeightMobile,
  }
}

const NavHeaderContainer = createContainer<NavHeaderState, NavHeaderArgs>(useNavHeaderImpl)

export const useNavHeader = NavHeaderContainer.useContainer
const NavHeaderProvider = NavHeaderContainer.Provider

export const NavHeaderClientProvider: React.FC<{
  hasPages: boolean
  children: React.ReactNode
}> = ({ hasPages, children }) => {
  return <NavHeaderProvider initialState={{ hasPages }}>{children}</NavHeaderProvider>
}
